import { h, Fragment } from "preact";

function SlideButton ({ id, serviceId }: {id: number, serviceId: string}) {
  return (
    <>
      {id !== 12 ? (
        <div className="index__wrapper-slider-slide-block-button button1">
          <a href={`/services/${serviceId}/`}>Заказать услугу</a>
        </div>
      ) : (
        <div className="index__wrapper-slider-slide-block-button button1">
          <a href={`/services/${serviceId}/`}>Подробнее о компании</a>
        </div>
      )}
    </>
  );
}

export { SlideButton };
